import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { decode } from 'base-64';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../redux/user';
import flixfrenzy from '../assets/flixfrenzy.webp';
import './Styles.css';

const Login = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const allUsers = useSelector((state) => state.user);

  const decodedPassword = decode(allUsers.password);

  const [emailColor, setEmailColor] = useState({});
  const [passColor, setpassColor] = useState({});
  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');
  const [userError, setUserError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();

    const email = e.target[0].value;
    const password = e.target[1].value;

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setEmailError('Please enter a valid email or phone number.');
      setEmailColor({ borderBottom: '1px solid #b92d2b' });
    } else if (password.length < 4) {
      setPassError('Your password must contain above 4 characters.');
      setpassColor({ borderBottom: '1px solid #b92d2b' });
    } else if (allUsers.email !== email || decodedPassword !== password) {
      setUserError('User not found');
    } else {
      const user = {
        email: allUsers.email,
        password: allUsers.password,
        login: true,
      };
      dispatch(getUser(user, { type: 'GET_USER' }));
    }
  };

  useEffect(() => {
    if (allUsers.login === true) {
      navigate('/');
      // window.location = '/';
    }
  });

  return (
    <div className="credentials-page">
      <div className="credentials-page-header">
        <img className="header-logo" src={flixfrenzy} alt="flixfrenzy logo" />
      </div>
      <div className="credentials-container">
        <h2 className="credentials-header">Sign In</h2>
        <div className="credentials-form-section">
          <form className="credentials-form" onSubmit={handleLogin}>
            <div className="single-input">
              <input type="text" className="input" name="email" style={emailColor} required />
              <span> Email or phone number </span>
              <p className="error">{emailError}</p>
            </div>
            <div className="single-input">
              <input type="password" className="input" name="password" style={passColor} required />
              <span> Password </span>
              <p className="error">{passError}</p>
            </div>
            <div className="single-input">
              <button type="submit" className="submit-btn">Sign In</button>
              <p className="error">{userError}</p>
            </div>
            <div className="remember-help">
              <div className="remember-check">
                <input type="checkbox" className="remember-check" />
                <p className="remember-text">Remember me</p>
              </div>
              <div className="need-help-section">
                <Link to="/help" className="need-help">Need help?</Link>
              </div>
            </div>
          </form>
        </div>
        <div className="other-links-section">
          <p className="new-to-flixfrenzy">New to FlixFrenzy?</p>
          <Link to="/sign-up" className="sign-up-link">Sign up now</Link>
        </div>
        <div className="notice">
          {/* <p>
            NB
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
